define(function(require) {
    return {
        LAYER_ID : "GEO07E16_POINTS_1_AN_SPES",
        LAYER_TYPE : "POINT",
        LOADING_MODE : "MANUAL",
        INDEX : 26,
        DATATABLE_ID : "t_GEO07E16_POINTS_1_AN_SPES",
        QUERY_FIELDS : ["GUID", "CD_POSTL", "LANGUE", "POP_1"],
        FIELDS : [
            {ID : "GUID", NAME : "GUID", DATA_TYPE : "STRING", VALUE : "{{GUID}}"},
            {ID : "CD_POSTL", NAME : "Code postal", DATA_TYPE : "STRING", VALUE : "{{CD_POSTL}}"},
            {ID : "LANGUE", NAME : "Langue", DATA_TYPE : "STRING", VALUE : "{{LANGUE}}"},
            {ID : "POP_1", NAME : "Nombre d'enfants de 1 an", DATA_TYPE : "NUMBER", VALUE : "{{POP_1}}"}
        ],
        STYLES : [
            {
               ID : "Anglophones",
               VALUE : "A",
               SYMBOLIZERS : [
                   {
                       SYMBOLIZER_TYPE : "SymbolPointSymbolizer",
                       COLOR : "rgba(253,44,2,1)",
                       FONT_NAME : "CartoVistaCartographic",
                       FONT_FILE_SOURCE : require("fonts/CartoVistaCartographic.ttf"),
                       SYMBOL_CHAR : "/",
                       SIZE : 10,
                       HAS_HALO : true,
                       HALO_COLOR : "rgba(0, 0, 0, 1)"
                   }
               ],
               STYLE_LABEL_PROPERTIES : {
                   BOLD : true,
                   COLOR : "rgba(184,33,3,1)",
                   FONT_NAME : "Arimo-Regular",
                   HALO_COLOR : "rgba(255,255,255,1)",
                   HAS_HALO_COLOR : true,
                   SIZE : 8,
                   VISIBLE : false
               }
           }, {
                ID : "Francophones",
                VALUE : "F",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "SymbolPointSymbolizer",
                        COLOR : "rgba(254,192,0,1)",
                        FONT_NAME : "CartoVistaCartographic",
                        FONT_FILE_SOURCE : require("fonts/CartoVistaCartographic.ttf"),
                        SYMBOL_CHAR : "/",
                        SIZE : 10,
                        HAS_HALO : true,
                        HALO_COLOR : "rgba(0, 0, 0, 1)"
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(176,137,16,1)",
                    FONT_NAME : "Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 8,
                    VISIBLE : false
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Enfants de 1 an",
            FEATURE_ID_DATACOLUMN : "GUID",
            FEATURE_NAME_DATACOLUMN : "CD_POSTL",
            DATATIP_DATACOLUMNS : ["CD_POSTL", "LANGUE", "POP_1"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["CD_POSTL", "LANGUE", "POP_1"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["CD_POSTL", "LANGUE", "POP_1"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            //SEARCHABLE_DATACOLUMNS : ["CD_POSTL"],
            SHOW_STYLES_IN_LAYER_CONTROL : true,
            STYLE_DATACOLUMN : "LANGUE",
            LABEL_DATACOLUMN : "POP_1",
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : true,
                LEADER_LINES : false,
                OFFSET_X : 2,
                POSITION : "MIDDLE-RIGHT",
                PRIORITY : 10,
                VISIBLE : false
            },
            VISIBLE : false,
            ZOOM_ON_FEATURE_SCALE : 6000
        }
    };
});
